import { ExpandableTableRow, FieldInput, InputKey, ShipmentItemInput, TableColumn } from 'generated/graphql';

const SKIP_COLUMN_INPUT_KEYS = [InputKey.None, InputKey.Form];

// Note: API sometimes sends '' or whitespace for non-keyed columns
const normalizeColumnInputKey = (inputKey: InputKey | string | null | undefined): string => {
  if (inputKey == null) return '';
  return String(inputKey).trim();
};

const shouldSkipColumnInputKey = (normalizedKey: string): boolean => {
  if (normalizedKey === '') return true;
  return SKIP_COLUMN_INPUT_KEYS.includes(normalizedKey as InputKey);
};

export function buildShipmentItemInputsForRows(
  columns: TableColumn[],
  rows: ExpandableTableRow[],
  options?: {
    formFields?: FieldInput[];
    cellValue?: (rowId: string, columnIndex: number, defaultValue: string) => string;
  },
): ShipmentItemInput[] {
  const valuesByKey = new Map<InputKey, FieldInput[]>();
  const formFields = options?.formFields ?? [];

  columns.forEach((column, columnIndex) => {
    const normalizedKey = normalizeColumnInputKey(column.inputKey);

    if (shouldSkipColumnInputKey(normalizedKey)) return;

    const inputKey = normalizedKey as InputKey;

    for (const row of rows) {
      const cell = row.cells[columnIndex];

      if (!cell) continue;

      const defaultValue = cell.value;

      const value = options?.cellValue?.(row.id, columnIndex, defaultValue) ?? defaultValue;

      const fieldInput: FieldInput = {
        id: column.id,
        value,
        values: [],
        entityID: row.id,
      };

      const currentInputKeyList = valuesByKey.get(inputKey);

      if (currentInputKeyList) {
        currentInputKeyList.push(fieldInput);
      } else {
        valuesByKey.set(inputKey, [fieldInput]);
      }
    }
  });

  return [
    { key: InputKey.Form, values: formFields },
    ...Array.from(valuesByKey.keys(), (key) => ({ key, values: valuesByKey.get(key)! })),
  ];
}
